export const SET_INPUT_SELECT_MODE = 'SET_INPUT_SELECT_MODE'
export const SET_INPUTS_SELECTED = 'SET_INPUTS_SELECTED'
export const SET_INPUT_SEARCH_MODE = 'SET_INPUT_SEARCH_MODE'
export const SET_INPUT_SEARCH = 'SET_INPUT_SEARCH'
export const START_HIGHLIGHT = 'START_HIGHLIGHT'
export const UPDATE_HIGHLIGHT_END = 'UPDATE_HIGHLIGHT_END'
export const CLEAR_HIGHLIGHT = 'CLEAR_HIGHLIGHT'
export const HIGHLIGHT_ALL = 'HIGHLIGHT_ALL'
export const SET_INPUT_MANUAL_SORT_MODE = 'SET_INPUT_MANUAL_SORT_MODE'
export const SET_HIGHLIGHT_MODE = 'SET_HIGHLIGHT_MODE'
export const SET_IMAGE_QUALITY = 'SET_IMAGE_QUALITY'
export const SET_LAST_FOCUSED_INPUT = 'SET_LAST_FOCUSED_INPUT'
